import { EmploymentType } from "@/types/form";

export const GRID_EMPLOYMENT_TYPES = [
	EmploymentType.PermanentEmployment,
	EmploymentType.FixedTermWorkContract,
	EmploymentType.Entrepreneur,
	EmploymentType.Student,
	EmploymentType.Pensioner,
	EmploymentType.OtherEmployment,
] as const;

const EMPLOYMENT_TYPES_WITH_WORK_DETAILS = new Set<EmploymentType>([
	EmploymentType.PermanentEmployment,
	EmploymentType.FixedTermWorkContract,
	EmploymentType.Entrepreneur,
]);

const EMPLOYMENT_TYPES_WITH_START_DATE = new Set<EmploymentType>([
	...EMPLOYMENT_TYPES_WITH_WORK_DETAILS,
	EmploymentType.Pensioner,
	EmploymentType.Incapacitated,
]);

export const employmentRequiresWorkDetails = (type?: EmploymentType) =>
	type !== undefined && EMPLOYMENT_TYPES_WITH_WORK_DETAILS.has(type);

export const employmentRequiresStartDate = (type?: EmploymentType) =>
	type !== undefined && EMPLOYMENT_TYPES_WITH_START_DATE.has(type);

export const isPensionEmploymentType = (type?: EmploymentType) =>
	type === EmploymentType.Pensioner || type === EmploymentType.Incapacitated;

export const toGridEmploymentType = (type?: EmploymentType) =>
	isPensionEmploymentType(type) ? EmploymentType.Pensioner : type;
